
const routes = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('pages/Home.vue'),
        beforeEnter (to, from, next) {
          // redirect to login if skey and oid are set
          if (to.query.sKey && to.query.oid) {
            next({
              path: '/login/' + to.query.oid + '/' + to.query.sKey
            })
          } else {
            next()
          }
        },
        meta: {
          nav: 'left'
        }
      },
      {
        path: '/persons',
        name: 'Persons',
        component: () => import('pages/Persons.vue'),
        meta: {
          nav: 'left'
        }
      },
      {
        path: '/person/:id',
        name: 'Person',
        component: () => import('pages/Person.vue'),
      },
      {
        path: '/courses',
        name: 'Courses',
        component: () => import('pages/Courses.vue'),
      },
      {
        path: '/publications',
        name: 'Publications',
        component: () => import('pages/Publications.vue'),
      },
      {
        path: '/articles',
        name: 'Articles',
        component: () => import('pages/Articles.vue'),
        meta: {
          session: true,
          roles: ['editor', 'admin']
        }
      },
      {
        path: '/article/:id',
        name: 'Article',
        component: () => import('pages/Article.vue')
      },
      {
        path: '/imprint',
        name: 'Imprint',
        component: () => import('pages/Imprint.vue')
      },
      {
        path: '/edit/:id',
        name: 'Edit',
        component: () => import('pages/Edit.vue'),
        meta: {
          session: true,
          roles: ['editor', 'admin']
        }
      },
      {
        path: '/settings',
        name: 'Settings',
        component: () => import('pages/Settings.vue'),
        meta: {
          session: true,
          roles: ['admin']
        }
      },
      {
        path: '/orgsettings',
        name: 'OrgSettings',
        component: () => import('pages/OrgSettings.vue')
      },
      {
        path: '/personssettings',
        name: 'PersonsSettings',
        component: () => import('pages/PersonsSettings.vue')
      },
      {
        path: '/edittissperson/:id',
        name: 'EditTissPerson',
        component: () => import('pages/EditTissPerson')
      },
      {
        path: '/editstoredperson/:id',
        name: 'EditStoredPerson',
        component: () => import('pages/EditStoredPerson')
      },
      {
        path: '/sso',
        name: 'SSO',
        component: () => import('pages/SSO.vue'),
        meta: {
          session: false
        }
      },
      {
        path: '/login/:oid/:sKey',
        name: 'Login',
        component: () => import('pages/Login.vue'),
        meta: {
          session: false
        }
      },
      {
        path: '/logout',
        name: 'Logout',
        component: () => import('pages/Logout.vue'),
        meta: {
          session: true
        }
      },

    ]
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/Error404.vue')
  }
]

export default routes
